<template>
  <div>
    <md-dialog-confirm
      class="new pink"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isShowingInquiryDialogConfirmComputed"
      md-title=""
      :md-content="confirmMessage"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="true"
      @md-confirm="handledInquireBtn"
    />

    <md-dialog
      :md-active.sync="isShowingInquiryDialog"
      :md-fullscreen="false"
      class="inquiry new"
      @md-opened="scroll('locked')"
      @md-closed="closedInquiryDialog"
    >
      <md-dialog-title>お問い合わせ</md-dialog-title>
      <div class="p-4">
        <textarea
          class="form-control"
          rows="6"
          v-model="inquiry"
          placeholder="お問い合わせ内容…"
        />
      </div>
      <md-dialog-actions class="mx-3">
        <button
          type="button"
          class="btn btn-link mr-3"
          @click="isShowingInquiryDialog = false"
        >
          閉じる
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="inquire"
          :disabled="!inquiry.length"
        >
          送信
        </button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin';

export default {
  name: 'InquiryDialog',

  components: {},

  mixins: [Mixin],

  props: {
    jyuchuSyaryoId: {
      type: Number,
      default: null,
      required: false,
    },
    isShowingInquiryDialogConfirm: {
      type: Boolean,
      required: true,
    },
    hikitoriYoteiBi: {
      type: String,
      default: null,
      required: false,
    },
  },

  data: () => ({
    inquiry: '',
    isShowingInquiryDialog: false,
    holidays: {},
  }),

  mounted() {
    this.fetchHolidays()
  },

  methods: {
    handledInquireBtn() {
      this.isTodayBeforePreviousBusinessDay
        ? this.gotoInquiry()
        : (this.isShowingInquiryDialog = true)
    },

    async inquire() {
      this.isShowingInquiryDialog = false
      this.spinerOn()

      await this.$store
        .dispatch('order/sendInquiryEmail', {
          jyuchuSyaryoId: this.jyuchuSyaryoId,
          inquiry: this.inquiry,
        })
        .then((res) => {
          console.log(res)
        })
        .catch((error) => {
          console.log(error)
        })

      this.spinerOff()
    },

    /**
     * 日本の祝日を取得
     */
    async fetchHolidays() {
      try {
        const response = await fetch(
          'https://holidays-jp.github.io/api/v1/date.json'
        )
        this.holidays = await response.json()
      } catch (error) {
        console.error('祝日データの取得に失敗しました:', error)
      }
    },

    closedInquiryDialog() {
      this.scroll('clear')
      this.inquiry = ''
    },
  },

  computed: {
    isShowingInquiryDialogConfirmComputed: {
      get() {
        return this.isShowingInquiryDialogConfirm
      },
      set(value) {
        this.$emit('update:isShowingInquiryDialogConfirm', value)
      },
    },

    confirmMessage() {
      return `<strong>ロジNAVIでのキャンセル・変更可能期間を過ぎたため受け付けることができませんでした。<br />恐れ入りますが、${
        this.isTodayBeforePreviousBusinessDay
          ? '当社部署まで直接お電話にてお問合せください'
          : '下記フォームより変更内容をお問い合わせください'
      }。</strong>`
    },

    /**
     * 引取予定日の予定日の2営業日前（土日祝除く）の日付を取得
     */
    twoBusinessDaysBeforePickup() {
      if (!this.hikitoriYoteiBi) {
        throw new Error('hikitoriYoteiBi is not null.')
      }

      const hikitoriYoteiBi = new Date(this.hikitoriYoteiBi)
      let businessDaysCount = 0

      while (businessDaysCount < 2) {
        hikitoriYoteiBi.setDate(hikitoriYoteiBi.getDate() - 1)
        const dayOfWeek = hikitoriYoteiBi.getDay()
        const formattedDate = hikitoriYoteiBi.toISOString().split('T')[0]

        // 土日や祝日を除外
        if (
          dayOfWeek !== 0 &&
          dayOfWeek !== 6 &&
          !this.holidays[formattedDate]
        ) {
          businessDaysCount++
        }
      }

      return hikitoriYoteiBi
    },

    /**
     * 当日の日付が twoBusinessDaysBeforePickup より前かを判定
     */
    isTodayBeforePreviousBusinessDay() {
      if (!this.hikitoriYoteiBi) {
        return false
      }

      const today = new Date()
      return today.getTime() < this.twoBusinessDaysBeforePickup.getTime()
    },
  },
}
</script>

<style lang="sass">
@import '../../assets/css/logico2'
.inquiry.md-dialog,
  .md-dialog-container
    width: 95%
    max-width: 700px
</style>



// WEBPACK FOOTER //
// src/components/order/InquiryDialog.vue